import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de l'erreur 404
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-erreur404',
  templateUrl: './erreur404.component.html',
  styleUrls: ['./erreur404.component.scss']
})
export class Erreur404Component extends BaseComponent implements OnInit {

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

}
